import React from 'react';
import PropTypes from 'prop-types';

import * as style from './ArticleNumberedHeading.module.scss';

/**
 * Heading with a number circle. Can be contain number + title and awards if variant=='full'
 */
const ArticleNumberedHeading = (props) => {
  const {
    number,
    title,
    variant,
    awardsList,
    setHoveredItemIndex,
    awardsElementsClassName,
    titleTag,
    className,
    ...rest
  } = props;

  const formAwardsList = (awardsArray) => {
    const resultingElements = [];
    for (let i = 0; i < awardsArray.length; i += 2) {
      resultingElements.push(
        <div key={i}>
          <span
            className={`${awardsElementsClassName} ${style.award}`}
            onClick={() => {
              setHoveredItemIndex(i);
            }}
          >
            {awardsArray[i]?.awardName}
          </span>
          {awardsArray[i + 1] && (
            <>
              <span className={style.dotSeparator}> · </span>
              <span
                className={`${awardsElementsClassName} ${style.award}`}
                onClick={() => {
                  setHoveredItemIndex(i + 1);
                }}
              >
                {awardsArray[i + 1]?.awardName}
              </span>
            </>
          )}
        </div>
      );
    }

    return resultingElements;
  };

  const getTitleWithTag = (titleText, titleTagName = 'h3') => {
    switch (titleTagName.toLowerCase()) {
      case 'h1': {
        return <h1 className={style.title}>{titleText}</h1>;
      }
      case 'h2': {
        return <h2 className={style.title}>{titleText}</h2>;
      }
      default:
      case 'h3': {
        return <h3 className={style.title}>{titleText}</h3>;
      }
      case 'h4': {
        return <h4 className={style.title}>{titleText}</h4>;
      }
      case 'h5': {
        return <h5 className={style.title}>{titleText}</h5>;
      }
      case 'h6': {
        return <h6 className={style.title}>{titleText}</h6>;
      }
      case 'p': {
        return <p className={style.title}>{titleText}</p>;
      }
    }
  };

  return (
    <div
      className={`${style.wrapper} ${
        variant === 'full' ? style.wrapperFull : ''
      } ${className}`}
      {...rest}
    >
      <div className={style.titleWrapper}>
        <div className={style.numberCircle}>
          <div
            className={`${
              number?.toString()?.length > 2
                ? style.numberTextSmaller
                : style.numberText
            }`}
          >
            {number}
          </div>
        </div>
        {getTitleWithTag(title, titleTag)}
      </div>
      {variant === 'full' && (
        <>
          <div className={style.description}>
            {awardsList && formAwardsList(awardsList)}
          </div>
          <div className={style.bgNumber}>{number}</div>
        </>
      )}
    </div>
  );
};
// TODO: document props
ArticleNumberedHeading.defaultProps = {
  awardsElementsClassName: '',
  awardsList: [],
  className: '',
  setHoveredItemIndex: () => {},
  titleTag: 'h3',
};

ArticleNumberedHeading.propTypes = {
  /** Numbered to be displayed in the circle */
  number: PropTypes.number.isRequired,
  /** Title text */
  title: PropTypes.string.isRequired,
  /** The Tag used to display the title (<h2>, <h3>, <h4>, <p>) */
  titleTag: PropTypes.string,
  /** Variant of the heading. Will contain awards if variant=='full' */
  variant: PropTypes.string.isRequired,
  /** List of awards - objects of the following format: { awardName, awardDescriptionPreselection }. */
  awardsList: PropTypes.array,
  /** Function to set the index of hovered (or clicked) item. */
  setHoveredItemIndex: PropTypes.func,
  /** Class name that will be ignored by 'useOnClickOutsideExceptClasses' hook. */
  awardsElementsClassName: PropTypes.string,
  /** Optional class name */
  className: PropTypes.string,
};

export default ArticleNumberedHeading;
